import { AlertInfoIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import { FormattedMessage } from 'react-intl';

import { MISC_REQUEST_TYPE_OPTIONS } from '../constants';

export const getFormFields = (messages, intl, chargeCodeOptions) => [
  {
    variant: 'singleSelect',
    name: 'requestType',
    label: <FormattedMessage {...messages.miscRequestTypeLabel} />,
    placeholder: intl.formatMessage(messages.miscRequestTypePlaceholder),
    options: MISC_REQUEST_TYPE_OPTIONS,
    fullWidth: true,
    rules: {
      required: true,
    },
    GridProps: {
      xs: 12,
    },
  },
  {
    variant: 'text',
    name: 'comments',
    label: <FormattedMessage {...messages.commentsLabel} />,
    placeholder: intl.formatMessage(messages.commentsPlaceholder),
    fullWidth: true,
    rules: {
      required: true,
      maxLength: {
        value: 78,
        message: intl.formatMessage(messages.commentsError),
      },
    },
    inputProps: {
      maxLength: 78,
    },
    InputProps: {
      multiline: true,
      minRows: 4,
      maxRows: 5,
    },
    GridProps: {
      xs: 12,
    },
  },
  {
    variant: 'currency',
    name: 'requestedAmount',
    label: <FormattedMessage {...messages.requestedAmountLabel} />,
    fullWidth: true,
    rules: {
      required: true,
      min: -999999999.99,
      max: 999999999.99,
    },
    GridProps: {
      xs: 12,
    },
  },
  {
    variant: 'singleSelect',
    name: 'propertyTransactionCodeId',
    label: <FormattedMessage {...messages.chargeCodeLabel} />,
    InputLabelProps: {
      shrink: true,
      TooltipProps: {
        title: intl.formatMessage(messages.chargeCodeTooltip),
        placement: 'right',
        children: <AlertInfoIcon fontSize="small" />,
      },
    },
    placeholder: intl.formatMessage(messages.chargeCodePlaceholder),
    options: chargeCodeOptions,
    fullWidth: true,
    rules: {
      required: true,
    },
    GridProps: {
      xs: 12,
    },
  },
];
